let { defaultState } = require('./state.js')

export default {
    reset: (state) => {
        Object.assign(state, defaultState())
    },
    set: (state, payload) => {
        Object.assign(state, payload)
    }
}
